import type { FC, PropsWithChildren } from 'react';
import { Flex, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { usePageContext } from 'vike-react/usePageContext';
import { Footer } from '@/components/Footer/Footer';
import { Navigation } from '@/components/Navigation/Navigation';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
    const { isMobile } = usePageContext();
    const { t } = useTranslation();

    if (isMobile) {
        return (
            <Flex align="center" justify="center" style={{ width: '100%', height: '100dvh', padding: 32 }}>
                <Typography.Heading level={4} align="center">
                    {t('Mobile_Stub')}
                </Typography.Heading>
            </Flex>
        );
    }

    return (
        <>
            <Navigation />
            <Flex flex="1 0 auto" justify="center">
                {children}
            </Flex>
            <Footer />
        </>
    );
};
